/*
 * @Author: YuanYuan
 * @Date: 2025-11-26 17:15:29
 * @LastEditTime: 2025-12-29 17:44:55
 * @Description: 套餐购买+升级+续费+试用
 */
export default [
  {
    path: '/floodShield/cs',
    component: () => import('@/views/purchase/floodShield/index.vue'),
    meta: {
      productType: 2
    }
  },
  {
    path: '/floodShield/ddos',
    component: () => import('@/views/purchase/floodShield/index.vue'),
    meta: {
      productType: 1
    }
  },
  {
    path: '/iplc',
    component: () => import('@/views/purchase/iplc/index.vue')
  },
  {
    path: '/floodShield/tryout',
    component: () => import('@/views/purchase/floodShield/tryout.vue')
  },
  {
    path: '/purchase/confirm',
    component: () => import('@/views/purchase/confirm.vue')
  },
  {
    path: '/aps/tryout',
    component: () => import('@/views/purchase/aps/tryout.vue')
  },
  {
    path: '/aps',
    component: () => import('@/views/purchase/aps/index.vue')
  },
  {
    path: '/purchase/pay',
    component: () => import('@/views/purchase/pay.vue')
  },
  {
    path: '/purchase/pay/success',
    component: () => import('@/views/purchase/paySuccess.vue')
  },
  {
    path: '/purchase/pay/failure',
    component: () => import('@/views/purchase/payFailure.vue')
  },
  {
    path: '/purchase/substitute/success',
    component: () => import('@/views/purchase/substituteSuccess.vue')
  }
]
